import Vue from 'vue'

export enum ShowFlagBusEvents {
    ShowFlagEvent = 'show_flag_bus',
}

export const showFlagBus = new Vue()
